/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Events_Group_Cta_BodyInputs */

const en_events_group_cta_body = /** @type {(inputs: Events_Group_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark hosts team and corporate group events on request.`)
};

const es_events_group_cta_body = /** @type {(inputs: Events_Group_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark organiza eventos grupales para equipos y empresas a pedido.`)
};

const de_events_group_cta_body = /** @type {(inputs: Events_Group_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Anfrage veranstaltet Mark Team- und Firmengruppenveranstaltungen.`)
};

const zh_events_group_cta_body = /** @type {(inputs: Events_Group_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark 可应要求为团队和企业团体举办活动。`)
};

const ar_events_group_cta_body = /** @type {(inputs: Events_Group_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ينظّم Mark فعاليات جماعية للفرق والشركات عند الطلب.`)
};

const fr_events_group_cta_body = /** @type {(inputs: Events_Group_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark organise des événements d'équipe et de groupe d'entreprise sur demande.`)
};

const vi_events_group_cta_body = /** @type {(inputs: Events_Group_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark tổ chức sự kiện nhóm cho đội và doanh nghiệp theo yêu cầu.`)
};

const sw_events_group_cta_body = /** @type {(inputs: Events_Group_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark huandaa matukio ya timu na ya vikundi vya makampuni kwa ombi.`)
};

const th_events_group_cta_body = /** @type {(inputs: Events_Group_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark เป็นเจ้าภาพจัดงานกิจกรรมกลุ่มและองค์กรตามคำขอ`)
};

const bs_events_group_cta_body = /** @type {(inputs: Events_Group_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark organizuje timske i korporativne grupne događaje na zahtjev.`)
};

const ja_events_group_cta_body = /** @type {(inputs: Events_Group_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markはご要望に応じて、チームや企業向けのグループイベントを開催します。`)
};

const ko_events_group_cta_body = /** @type {(inputs: Events_Group_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`요청 시 Mark가 팀 및 기업 단체 행사를 진행합니다.`)
};

const pt_events_group_cta_body = /** @type {(inputs: Events_Group_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark organiza eventos para equipes e grupos corporativos sob consulta.`)
};

const it_events_group_cta_body = /** @type {(inputs: Events_Group_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Su richiesta Mark organizza eventi per squadre e gruppi aziendali.`)
};

const sv_events_group_cta_body = /** @type {(inputs: Events_Group_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark ordnar evenemang för lag och företagsgrupper på begäran.`)
};

const nl_events_group_cta_body = /** @type {(inputs: Events_Group_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Op aanvraag organiseert Mark evenementen voor teams en bedrijfsgroepen.`)
};

const da_events_group_cta_body = /** @type {(inputs: Events_Group_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark arrangerer på forespørgsel arrangementer for hold og firmagrupper.`)
};

const nb_events_group_cta_body = /** @type {(inputs: Events_Group_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark arrangerer lag- og bedriftsarrangementer på forespørsel.`)
};

const fi_events_group_cta_body = /** @type {(inputs: Events_Group_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark järjestää pyynnöstä tapahtumia joukkueille ja yritysryhmille.`)
};

const pl_events_group_cta_body = /** @type {(inputs: Events_Group_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na życzenie Mark organizuje wydarzenia dla drużyn i grup firmowych.`)
};

const ru_events_group_cta_body = /** @type {(inputs: Events_Group_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark проводит командные и корпоративные групповые мероприятия по запросу.`)
};

const tr_events_group_cta_body = /** @type {(inputs: Events_Group_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark, talep üzerine takımlar ve şirket grupları için etkinlikler düzenler.`)
};

const hi_events_group_cta_body = /** @type {(inputs: Events_Group_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुरोध पर Mark टीमों और कॉर्पोरेट समूहों के लिए इवेंट आयोजित करते हैं।`)
};

const id_events_group_cta_body = /** @type {(inputs: Events_Group_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atas permintaan, Mark menyelenggarakan acara untuk tim dan grup perusahaan.`)
};

const ms_events_group_cta_body = /** @type {(inputs: Events_Group_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atas permintaan, Mark menganjurkan acara untuk pasukan dan kumpulan korporat.`)
};

const cs_events_group_cta_body = /** @type {(inputs: Events_Group_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark na požádání pořádá akce pro týmy a firemní skupiny.`)
};

const el_events_group_cta_body = /** @type {(inputs: Events_Group_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ο Mark φιλοξενεί ομαδικές και εταιρικές διοργανώσεις κατόπιν αιτήματος.`)
};

const he_events_group_cta_body = /** @type {(inputs: Events_Group_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark מארח אירועים לקבוצות ולחברות לפי בקשה.`)
};

const af_events_group_cta_body = /** @type {(inputs: Events_Group_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark bied op aanvraag span- en korporatiewe groepgeleenthede aan.`)
};

const hu_events_group_cta_body = /** @type {(inputs: Events_Group_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kérésre Mark csapat- és céges csoportos eseményeket is szervez.`)
};

/**
* | output |
* | --- |
* | "Mark hosts team and corporate group events on request." |
*
* @param {Events_Group_Cta_BodyInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const events_group_cta_body = /** @type {((inputs?: Events_Group_Cta_BodyInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Events_Group_Cta_BodyInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_events_group_cta_body(inputs)
	if (locale === "de") return de_events_group_cta_body(inputs)
	if (locale === "zh") return zh_events_group_cta_body(inputs)
	if (locale === "ar") return ar_events_group_cta_body(inputs)
	if (locale === "fr") return fr_events_group_cta_body(inputs)
	if (locale === "vi") return vi_events_group_cta_body(inputs)
	if (locale === "sw") return sw_events_group_cta_body(inputs)
	if (locale === "th") return th_events_group_cta_body(inputs)
	if (locale === "bs") return bs_events_group_cta_body(inputs)
	if (locale === "ja") return ja_events_group_cta_body(inputs)
	if (locale === "ko") return ko_events_group_cta_body(inputs)
	if (locale === "pt") return pt_events_group_cta_body(inputs)
	if (locale === "it") return it_events_group_cta_body(inputs)
	if (locale === "sv") return sv_events_group_cta_body(inputs)
	if (locale === "nl") return nl_events_group_cta_body(inputs)
	if (locale === "da") return da_events_group_cta_body(inputs)
	if (locale === "nb") return nb_events_group_cta_body(inputs)
	if (locale === "fi") return fi_events_group_cta_body(inputs)
	if (locale === "pl") return pl_events_group_cta_body(inputs)
	if (locale === "ru") return ru_events_group_cta_body(inputs)
	if (locale === "tr") return tr_events_group_cta_body(inputs)
	if (locale === "hi") return hi_events_group_cta_body(inputs)
	if (locale === "id") return id_events_group_cta_body(inputs)
	if (locale === "ms") return ms_events_group_cta_body(inputs)
	if (locale === "cs") return cs_events_group_cta_body(inputs)
	if (locale === "el") return el_events_group_cta_body(inputs)
	if (locale === "he") return he_events_group_cta_body(inputs)
	if (locale === "af") return af_events_group_cta_body(inputs)
	if (locale === "hu") return hu_events_group_cta_body(inputs)
	return en_events_group_cta_body(inputs)
});